import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { IndicadoresPgService } from "../services/indicadores-pg.service";

@Injectable({
  providedIn: 'root'
})
export class IndicadoresSimplificadoPgResolver implements Resolve<boolean> {

  constructor(private service: IndicadoresPgService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getByIdSimple(route.params.id);
  }
}

@Injectable({
  providedIn: 'root'
})
export class IndicadoresPgListResolver implements Resolve<boolean> {

  constructor(private service: IndicadoresPgService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getByIdList();
  }
}

@Injectable({
  providedIn: 'root'
})
export class IndicadoresPgListEditResolver implements Resolve<boolean> {

  constructor(private service: IndicadoresPgService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getByIdListEdit(route.params.id);
  }
}

@Injectable({
  providedIn: 'root'
})
export class IndicadoresPgResolver implements Resolve<boolean> {

  constructor(private service: IndicadoresPgService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}